module.exports = __webpack_public_path__ + "img/case1.9a435d31.png";